import {
  addDoc,
  collection,
  doc,
  serverTimestamp,
  setDoc,
} from "firebase/firestore";
import {
  db,
  firebaseFunctions,
} from "@poseidon/firebase/firebase";
import config from "@poseidon/utils/config";

export const updateApplication = async (applicationId, fields) => {
  //strip out stuff that should be references
  //todo: fix properly
  const { vessel, applicants, application, dealer, checkList, ...update } =
    fields;
  if (dealer?.id) {
    update.dealer = doc(db, "dealers", dealer.id);
  }

  if (vessel?.id) {
    update.vessel = doc(db, "boats", vessel.id);
  }
  if (applicants) {
    //todo: is this needed?
  }
  await setDoc(doc(db, "applications", applicationId), update, { merge: true });
};

export const updateCreditUnderwriting = async (applicationId, fields) => {
  await setDoc(
    doc(db, "applications", applicationId, "creditUnderwriting", "current"),
    fields,
    { merge: true }
  );
};

export const setAction = async (
  entity,
  entityId,
  entityKey,
  { state, note, actionFor },
  userId
) => {
  try {
    const actionForValue = getUserReferenceFromActionFor(state, actionFor);

    await setDoc(
      doc(db, entity, entityId, config.SaltCollection._action, entityKey),
      {
        actionFor: actionForValue,
        note,
        state,
        updatedBy: {
          user: doc(db, "admins", userId),
          userType: "admin",
        },
      },
      { merge: true }
    );
  } catch (error) {
    return Error(error);
  }
};

const getUserReferenceFromActionFor = (state, actionFor) => {
  if (!actionFor || state === "pendingApproval" || actionFor === "admin") {
    return "admin";
  }

  if (actionFor && actionFor !== "admin") {
    const [collection, id] = actionFor.split("/");
    return doc(db, collection, id);
  }
};

export async function addNote({
  title,
  body,
  user,
  application,
  noteCategory,
}) {
  const values = {
    title,
    body,
    postedBy: doc(db, "admins", user.uid),
    createdAt: serverTimestamp(),
  };

  await addDoc(
    collection(db, "applications", application.id, noteCategory),
    values
  );
}

export const runAffordabilityReport = async (applicationId) => {
  try {
    firebaseFunctions.affordabilityCheck({ applicationId });
  } catch (error) {
    console.error("Error calling function", error);
  }
};

export const updateAffordabilityReport = async (applicationId, manual) => {
  await setDoc(
    doc(db, "applications", applicationId, "affordabilityReport", "current"),
    {
      manual,
    },
    { merge: true }
  );
};
